/**
 * Uses dipatcher 'redraw' event to wire up the group member item in the list.
 */
import $ from 'jquery'

import View from 'view/view'
import Modal from 'component/modal/modal'
import PaywallView from 'component/paywall/paywall'
import Router from 'service/router'
import io from 'service/io'
import dataProvider from 'service/data_provider'
import InviteToGroupFormView from 'bundle/activity_group/view/invite_to_group_form'

export default View.extend({
    events: {
        'click .js-show-invite-friends, .js-show-invite-friends-text': '_onShowInviteFriendsClick',
    },

    bubbleEvents: {
        'Paywall:close': '_onPaywallClose',
    },

    initialize() {
        this._initJoinButton()
    },

    _onShowInviteFriendsClick(e) {
        const $target = $(e.target).closest('.js-show-invite-friends')
        const modalOptions = Modal.getData($target)
        const modalView = this.initSubview(Modal, modalOptions)

        modalView.on('Modal:opened', (payload) => {
            this.initSubview(InviteToGroupFormView, {
                el: payload.container,
            }).render()
        })
    },

    _onPaywallClose() {
        const url = Router.path('activity_group_subscription_post', {
            activityGroupId: dataProvider.get('activityGroup').id,
        })

        io.request(url, { method: 'POST', data: { _token: dataProvider.get('csrfToken') } })
    },

    _initJoinButton() {
        this.initSubview(PaywallView, {
            el: this.$('.js-paywall'),
            paywallType: 'group',
            upgradeHandler: 'activity_group',
            upgradeHandlerParameters: { activityGroupId: dataProvider.get('activityGroup').id },
        })
    },
})
